import React, { useRef } from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import Footer from "./footer";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  // Handle form submission
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_57t6coz", // Your EmailJS service ID
        "template_gd3u4yi", // Your EmailJS template ID
        form.current,
        "Te2wg9HiuBVhpkw1E" // Your EmailJS public key
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          alert("Your message has been sent successfully!");
          e.target.reset();
        },
        (error) => {
          console.error("Email sending failed:", error.text);
          alert("Oops! Something went wrong. Please try again later.");
        }
      );
  };

  return (
    <div id="contact" className="bg-[#FFEFE6] w-screen max-w-none">
      <section className="relative py-16 px-6 md:px-20 overflow-hidden">
        {/* Main Container */}
        <div className="relative max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start gap-12 z-10">
          {/* Left Side */}
          <div className="w-full md:w-1/2 space-y-6">
            <h2 className="text-3xl font-bricolage md:text-4xl font-bold text-[#000000] leading-tight">
              Have Questions? <br /> Reach Out!
            </h2>

            <p className="text-gray-700 text-base md:text-lg max-w-md">
              Get in Touch: We're Here to Assist! Feel Free to Reach Out with Any
              Questions.
            </p>

            {/* Contact Details */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="bg-[#F15A29] w-8 h-8 rounded-full flex items-center justify-center">
                  <FaPhoneAlt className="text-white text-sm" />
                </div>
                <span className="text-gray-800 font-medium text-base">
                  +91 8089559615
                </span>
              </div>

              <div className="flex items-center gap-3">
                <div className="bg-[#F15A29] w-8 h-8 rounded-full flex items-center justify-center">
                  <FaEnvelope className="text-white text-sm" />
                </div>
                <span className="text-gray-800 font-medium text-base">
                btechmathemtics4u@gmail.com
                </span>
              </div>
            </div>
          </div>

          {/* Right Side (Form) */}
          <div className="w-full md:w-1/2 relative flex items-center justify-center">
            {/* Background Circles (Centered & Outlined - Behind Form) */}
            <div className="absolute inset-0 flex items-center justify-center -z-10">
              <div className="absolute w-[450px] h-[450px] rounded-full border border-[#F8B68B] opacity-60"></div>
              <div className="absolute w-[320px] h-[320px] rounded-full border border-[#F8B68B] opacity-60"></div>
              <div className="absolute w-[200px] h-[200px] rounded-full border border-[#F8B68B] opacity-60"></div>
            </div>

            {/* EmailJS Form */}
            <form
              ref={form}
              onSubmit={sendEmail}
              className="relative z-10 bg-transparent space-y-4 w-full max-w-md"
            >
              <input
                type="email"
                name="user_email"
                placeholder="Enter your email"
                required
                className="w-full bg-white rounded-xl border border-gray-200 py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#F15A29] text-gray-700"
              />
              <input
                type="text"
                name="user_name"
                placeholder="Your full name"
                required
                className="w-full bg-white rounded-xl border border-gray-200 py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#F15A29] text-gray-700"
              />
              <textarea
                rows="4"
                name="message"
                placeholder="Free Message"
                required
                className="w-full bg-white rounded-xl border border-gray-200 py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#F15A29] text-gray-700 resize-none"
              ></textarea>

              {/* Submit Button & Text */}
              <div className="flex items-center gap-4">
                <button
                  type="submit"
                  className="bg-[#F15A29] hover:bg-[#d44c1f] text-white font-semibold px-8 py-3 rounded-full transition-all"
                >
                  Submit
                </button>
                <p className="text-gray-500 text-sm max-w-[220px]">
                We’ll get back to you as soon as possible.
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
